import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CaseList } from './case-list';
import { CaseDetail } from '@codametrix/shared-views';
import { CaseDetailv2 } from '@codametrix/shared-views';
import React, { useEffect, useState } from 'react';
import history from '../../../history';
import { useDispatch, useSelector } from 'react-redux';
import { AmplifyCore, appServiceLines, codeBenchActions, commonEnums as enums } from '@codametrix/ui-common';
const { toServiceLineSlug, normalizeServiceLineName } = appServiceLines;
const CaseListAndDetail = (props)=>{
    const dispatch = useDispatch();
    const hasAmplifyCaseRunV2Access = useSelector((state)=>state.ui.context.activeContext ? AmplifyCore.benchEditable.isResourceAllowed(state.ui.context.activeContext, enums.ResourceId.AMPLIFY_CASE_RUN_V2, state.ui.serviceLine?.name ?? 'default') : false);
    const context = useSelector((state)=>{
        return state.ui.context;
    });
    const { params = {} } = props.match ?? {};
    const detailProps = {
        ...props.detailProps,
        ...props.detailMethods,
        tenantId: context.activeContext?.tenantId,
        hasAmplifyCaseRunV2Access
    };
    const listProps = {
        ...props.listProps,
        context,
        ...props.listMethods
    };
    const [isDetailOpen, setIsDetailOpen] = useState(params.id !== undefined);
    const handleSelection = (item)=>{
        const serviceLineConfig = appServiceLines.determineServiceLineConfig({
            name: item.service_line,
            caseIdentifier: `${item.case_uid || item.case_id}`
        });
        const caseId = serviceLineConfig.caseIdProp in item ? item[serviceLineConfig.caseIdProp] : item.case_id;
        const serviceLine = toServiceLineSlug(normalizeServiceLineName(String(params.serviceLine ?? '')));
        const targetPath = `/cmx/cases/${serviceLine}/${caseId}/`;
        // Always push an absolute path. A bare segment (history.push(caseId)) is resolved
        // against the *last* URL path segment; without a trailing slash on /cmx/cases/:sl
        // that incorrectly becomes /cmx/cases/:caseId and breaks the stack for browser Back.
        if (history.location.pathname.replace(/\/$/, '') !== targetPath.replace(/\/$/, '')) {
            history.push(targetPath);
        }
        setIsDetailOpen(true);
    };
    const handleBackClick = (event)=>{
        dispatch(codeBenchActions.showSideNavBar());
        history.push(`/cmx/cases/${toServiceLineSlug(normalizeServiceLineName(params.serviceLine ?? ''))}/`);
        setIsDetailOpen(false);
    };
    useEffect(()=>{
        setIsDetailOpen(params.id !== undefined);
    }, [
        params.id
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: isDetailOpen ? 'none' : 'flex',
                    flexDirection: 'column',
                    flex: '1 1 0',
                    minHeight: 0
                },
                children: /*#__PURE__*/ _jsx(CaseList, {
                    ...listProps,
                    onSelection: handleSelection
                })
            }),
            isDetailOpen ? hasAmplifyCaseRunV2Access ? /*#__PURE__*/ _jsx(CaseDetailv2, {
                ...detailProps,
                handleBackClick: handleBackClick,
                match: props.match,
                context: context
            }) : /*#__PURE__*/ _jsx(CaseDetail, {
                ...detailProps,
                handleBackClick: handleBackClick,
                match: props.match,
                context: context
            }) : null
        ]
    });
};
export { CaseListAndDetail };
